import { type MCPServerInfo } from '../../types';

const GoogleCalendarOfficialServer: MCPServerInfo = {
  serverId: 'GOOGLE_CALENDAR_OFFICIAL',
  name: 'Google Calendar (Official)',
  slug: 'google-calendar-v2',
  description:
    'Official Google-hosted Calendar MCP Server for listing calendars, managing events, and scheduling',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://calendarmcp.googleapis.com/mcp/v1',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleCalendarOfficialServer;
